import { render } from "./TheFooter.vue?vue&type=template&id=0f83c184&scoped=true"
import script from "./TheFooter.vue?vue&type=script&lang=js"
export * from "./TheFooter.vue?vue&type=script&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=0f83c184&scoped=true&lang=css"
import "./TheFooter.vue?vue&type=style&index=1&id=0f83c184&scoped=true&lang=css"

import exportComponent from "/home/runner/work/eeej-spa/eeej-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f83c184"]])

export default __exports__